<template>
  <b-container>
    <b-card class="h-100">
      <!-- Notifications -->
      <b-list-group>
        <!-- Cart Footer -->
        <b-list-group-item
          class="dropdown-menu-footer d-flex justify-content-center align-content-center align-content-end w-75 m-auto border-0"
        >
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-danger"
            @click="clearNotifications()"
          >
            Effacer mes notifications</b-button>
        </b-list-group-item>
        <!-- Account Notification -->
        <b-link
          v-for="(notification, index) in notifications"
          :key="index"
          class="d-flex align-items-center"
        >
          <b-list-group-item
            class="m-auto w-75"
            :class="{ 'alert-primary': !notification.seen }"
          >
            <b-media @click="goTo(notification)">
              <template #aside>
                <b-avatar
                  size="32"
                  :text="notification.avatar"
                  :variant="notification.css"
                />
              </template>
              <p class="media-heading">
                <span class="font-weight-bolder">
                  {{ notification.title }}
                </span>
              </p>
              <small class="notification-text">{{
                notification.subtitle
              }}</small>
              <br>
              <small class="notification-text">{{
                notification.date_creation
              }}</small>
            </b-media>
          </b-list-group-item>
        </b-link>
      </b-list-group>
    </b-card>
  </b-container>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    VuePerfectScrollbar,
  },
  directives: {
    Ripple,
  },
  setup() {
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    }

    return {
      perfectScrollbarSettings,
    }
  },
  computed: {
    ...mapGetters('notifications', { notifications: 'GET_NOTIFICATIONS' }),
    seen() {
      return this.notifications.filter(notification => !notification.seen)
        .length
    },
    ...mapGetters('auth', {
      user: 'GET_USER_DATA',
      is_reject_blocked: 'IS_REJECTED',
    }),
  },
  watch: {
    notifications(val) {},
  },
  async mounted() {
    if (this.seen > 0) {
      setTimeout(() => {
        this.MAKE_ALL_SEEN(this.user.id)
      }, 1000)
    }
  },
  methods: {
    ...mapActions('notifications', ['MAKE_ALL_SEEN', 'CLEAR_NOTIFICATIONS']),
    async clearNotifications() {
      await this.CLEAR_NOTIFICATIONS(this.user.id)
    },
    async makeAllSeen() {
      await this.MAKE_ALL_SEEN(this.user.id)
    },
    goTo(item) {
      let path = null

      if (item.type_contract) {
        switch (item.type_contract) {
          case 'ProximusContrat':
            path = 'DetailProximus'
            break
          case 'LampirisContrat':
            path = 'DetailMega'
            break
          case 'UCareContrat':
            path = 'DetailUCare'
            break
          case 'ConventionContrat':
            path = 'DetailConventions'
            break
        }
      } else if (item.title == 'Solvabilité Client') {
        path = 'DetailClients'
      }
      if (path) {
        this.$router.push({ name: path, params: { id: item.id } })
      }
    },
  },
}
</script>

<style></style>
